import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-coupon-info',
  templateUrl: './coupon-info.component.html',
  styleUrls: ['./coupon-info.component.scss'],
})
export class CouponInfoComponent implements OnInit {
  constructor(
  ) { }

  @Input() couponDetails;
  couponMsg;
  ngOnInit(): void {
    this.couponMsg = this.getCouponMsg(this.couponDetails);
  }

  getCouponMsg(couponDetails) {
    const criteria = JSON.parse(couponDetails?.criteria);
    switch (couponDetails.type) {
      case 'Coupon Offer':
        return `The first Impact Contribution of "₹ ${criteria.max_coupon_amount}" on this fundraiser is made by Ketto.`;
      case 'Matching Offer':
        return `Ketto will be matching "${criteria.percentage}%" of your contribution on this fundraiser`;
    }
  }
}
